import Privacy from "./Privacy";
import Terms from "./Terms";
import Disclosures from "./Disclosures";

export { Privacy, Terms, Disclosures };



// WEBPACK FOOTER //
// ./src/pages/Legal/Index.tsx